module.exports = __webpack_public_path__ + "static/turquia-004.thumb-da9691cbe6317bcd7d27a231786b8ff4.jpg";